import React, { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { deleteData, getData, putData } from "../../../../services/http.service";
import Constants from "../../../../services/constant";
import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import { confirmDialog } from "primereact/confirmdialog";
import { InputText } from "primereact/inputtext";
import { useHistory } from "react-router-dom";
import { Editor } from "primereact/editor";

const ProviderPrivacyPolicy = () => {
    const toast = useRef(null);
    // const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState({});
    const [privacy, setPrivacy] = useState({
        heading: "",
        paragraphText: "",
        id: "",
    });
    const [text, setText] = useState("");
    const [isEditable, setIsEditable] = useState(false);

    const deletePrivacyPolicy = () => {
        deleteData(Constants.END_POINT.DELETE_PRIVACY_POLICY + privacy.id).then((res) => {
            if (res.success) {
                toast.current.show({ severity: "info", summary: "", detail: "Privacy Policy Deleted Succesfully", life: 3000 });
                setIsEditable(false);
                getAllPrivacyPolicy();
            }
        });
    };

    const getAllPrivacyPolicy = () => {
        getData(`${Constants.END_POINT.GET_PRIVACY_POLICY}?type=PROVIDER`)
            .then((res) => {
                console.log("res===>", res);

                if (res.success) {
                    setText(res?.data?.paragraphText);
                    let obj = {
                        heading: res?.data?.heading,
                        paragraphText: res?.data?.paragraphText,
                        id: res?.data?._id,
                    };
                    setPrivacy(obj);
                    setLoading(false);
                } else {
                    setText("");
                    let obj = {
                        heading: "",
                        paragraphText: "",
                        id: "",
                    };
                    setPrivacy(obj);
                    setLoading(false);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const validateForm = () => {
        let errors = {};
        if (privacy.heading.length === 0) {
            errors.seasonName = "heading is required";
        }
        if (privacy.paragraphText.length === 0) {
            errors.seasonName = "privacy policy is required";
        }

        setErr(errors);
        if (Object.keys(errors).length === 0) {
            return true;
        } else {
            return false;
        }
    };

    const handleSubmit = (e) => {
        setLoading(true);
        e.preventDefault();
        const form = validateForm();
        if (form) {
            let paylaod = {
                type: "PROVIDER",
                heading: privacy.heading,
                paragraphText: text,
            };
            putData(Constants.END_POINT.UPDATE_PRIVACY_POLICY + privacy.id, paylaod)
                .then((res) => {
                    if (res.success) {
                        console.log("res", res);
                        toast.current.show({ severity: "info", summary: "", detail: "Privacy policy has been Updated Succesfully", life: 3000 });
                        setIsEditable(false);
                        getAllPrivacyPolicy();
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
        setLoading(false);
    };

    const handleChangeTerms = (e) => {
        const { name, value } = e.target;
        setPrivacy((prev) => {
            return {
                ...prev,
                [name]: value,
            };
        });
        setErr({ ...err, [name]: "" });
    };

    const acceptFunc = () => {
        deletePrivacyPolicy();
        // toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
    };

    const reject = () => {
        // toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    };

    const deleteConfirm = () => {
        confirmDialog({
            message: "Do you want to delete this record?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            rejectClassName: "cancel-button",
            accept: () => acceptFunc(),
            reject,
        });
    };

    console.log("termsms", privacy);

    useEffect(() => {
        getAllPrivacyPolicy();
    }, []);
    return (
        <div className="col-12">
            <div className="card">
                {console.log("privacy", privacy)}
                <div className="flex justify-content-between mb-4">
                    <Toast ref={toast} />
                    <h5>Privacy Policy</h5>
                    {console.log("is--", isEditable)}
                    <div className="flex justify-content-end mr-3">
                        {!isEditable && privacy?.heading !== undefined && privacy?.paragraphText !== undefined ? (
                            <>
                                <Button className="button" icon="pi pi-pencil" label="Edit " style={{ height: "max-content", marginLeft: "1rem" }} onClick={() => setIsEditable(true)} />

                                <Button className="p-button-danger" icon="pi pi-trash" label="Delete " style={{ height: "max-content", marginLeft: "1rem" }} onClick={deleteConfirm} />
                            </>
                        ) : null}
                        {privacy?.heading === undefined && privacy?.paragraphText === undefined ? (
                            <Link to="/create-provider-privacy-policy" style={{ height: "max-content" }}>
                                <Button className="p-button-info" icon="pi pi-plus" label="Create Privacy Policy" />
                            </Link>
                        ) : null}

                        {/* <Button label="Export" icon="pi pi-upload" className="p-button-help ml-3" onClick={() => ExportCSV(exportData)} /> */}
                    </div>
                </div>
                {privacy?.heading === undefined && privacy?.paragraphText === undefined ? (
                    <div>No Privacy Policy Found</div>
                ) : (
                    <div className="p-fluid grid question-div-wrapper mt-4">
                        <div className="field col-12 md:col-12">
                            <span className="p-float-label">
                                <InputText className={isEditable ? "editable" : "noEditable"} id="heading" name="heading" onChange={handleChangeTerms} value={privacy.heading} />
                                <label htmlFor="heading">Heading</label>
                            </span>
                        </div>

                        <div className="field col-12 md:col-12">
                            <span className="">
                                <div className="">
                                    <Editor className={isEditable ? "editable" : "noEditable"} value={text} onTextChange={(e) => setText(e.htmlValue)} style={{ height: "320px" }} />
                                </div>
                            </span>
                        </div>
                    </div>
                )}

                <div className="flex justify-content-left mt-3 ">
                    {isEditable ? (
                        <Button type="button" className="p-button-md p-component" onClick={handleSubmit}>
                            Update Privacy Policy
                        </Button>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default ProviderPrivacyPolicy;
